import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeProjectCreate,
  detail: routeProjectDetail,
  home: routeProjectsHome,
  root: routeProjectsRoot,
} = createDoctypeRoutes({
  createName: 'new-project',
  createPath: 'new-project',
  detailName: 'projectDetail',
  doctype: DOCTYPES.PROJECT,
  homeName: 'projects',
  path: 'projects',
  views: {
    create: async () => await import('@/components/viewsExternal/projects/AddProject.vue'),
    detail: async () => await import('@/components/viewsExternal/projects/ViewProject.vue'),
    list: async () => await import('@/components/viewsExternal/projects/ProjectView.vue'),
  },
})

export { routeProjectCreate, routeProjectDetail, routeProjectsHome, routeProjectsRoot }
